"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./ButtonStyles"));
var react_feather_1 = require("react-feather");
var LoadingSpinner_1 = __importDefault(require("../../LoadingSpinner"));
var Button = function (_a) {
    var className = _a.className, children = _a.children, height = _a.height, width = _a.width, fullWidth = _a.fullWidth, _b = _a.variant, variant = _b === void 0 ? "primary" : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, isPending = _a.isPending, withImage = _a.withImage, onClick = _a.onClick, disabled = _a.disabled, tooltip = _a.tooltip, enabled = _a.enabled, minWidth = _a.minWidth, _d = _a.margin, margin = _d === void 0 ? "0.8rem" : _d, id = _a.id, isIconButton = _a.isIconButton, selected = _a.selected, _e = _a.subtleBorder, subtleBorder = _e === void 0 ? false : _e, removeHoverOnClick = _a.removeHoverOnClick, hideCheckOnSelection = _a.hideCheckOnSelection, inline = _a.inline, toastInline = _a.toastInline, borderRadius = _a.borderRadius, padding = _a.padding, _f = _a.checkMark, checkMark = _f === void 0 ? React.createElement(react_feather_1.Check, null) : _f, props = __rest(_a, ["className", "children", "height", "width", "fullWidth", "variant", "size", "isPending", "withImage", "onClick", "disabled", "tooltip", "enabled", "minWidth", "margin", "id", "isIconButton", "selected", "subtleBorder", "removeHoverOnClick", "hideCheckOnSelection", "inline", "toastInline", "borderRadius", "padding", "checkMark"]);
    var _g = React.useState(false), justClicked = _g[0], setJustClicked = _g[1];
    var isButtonDisabled = disabled || isPending;
    var isIconButtonValue = typeof children === "object" &&
        Object.prototype.toString.call(children) !== "[object Array]";
    var iconPosition = "left";
    if (typeof children === "object" &&
        Object.prototype.toString.call(children) === "[object Array]") {
        React.Children.map(children, function (child, idx) {
            if (idx === 0 && typeof child === "string") {
                iconPosition = "right";
            }
        });
    }
    var handleClick = function (event) {
        if (onClick && !disabled) {
            onClick(event);
        }
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        if (removeHoverOnClick) {
            setJustClicked(true);
        }
    };
    return (React.createElement(Styled.Button, __assign({ variant: variant, height: height, width: width, disabled: isButtonDisabled, tooltip: tooltip, enabled: enabled, onClick: handleClick, size: size, minWidth: minWidth, id: id, isIconButton: isIconButtonValue, selected: selected, subtleBorder: subtleBorder, fullWidth: fullWidth, removeHoverOnClick: removeHoverOnClick && justClicked, onMouseLeave: function () { return (removeHoverOnClick ? setJustClicked(false) : null); }, inline: inline, toastInline: toastInline, borderRadius: borderRadius, margin: margin, padding: padding }, props),
        React.createElement(Styled.ButtonContent, __assign({ visible: !isPending, size: size, isIconButton: isIconButtonValue, iconPosition: iconPosition || "left" }, props),
            selected && !hideCheckOnSelection && checkMark,
            children),
        React.createElement(Styled.ButtonTextSpinner, { visible: isPending },
            React.createElement(LoadingSpinner_1.default, null))));
};
exports.default = Button;
